/* eslint-disable */
import React, { useState } from "react";
import "contents/assets/scss/page/books.scss";
import Paging from "../../component/Inc/Paging";
import Tab from "../../component/Inc/Tab";
import PopBookStock from "./_PopBookStock";

const Stocks = () => {
  const [modalBookStockOpen, setModalBookStockOpen] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const tab = [
    { title: "국어(64)", cnt: "64", value: 0 },
    { title: "영어", cnt: "842", value: 1 },
    { title: "수학", cnt: "654", value: 2 },
    { title: "사탐", cnt: "45", value: 3 },
    { title: "과탐", cnt: "64", value: 4 },
    { title: "수시", cnt: "64", value: 4 },
  ];
  return (
    <main className="com_container com_books p_books_stock">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu3_7">교재 재고관리</h2>
          <button
            onClick={() => setModalBookStockOpen(true)}
            className="com_btn orange s btn_settings"
          >
            교재 관리
          </button>
        </section>
        <section className="com_pg_container">
          <section className="box full">
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} setTab={setTabIdx} />
              <div className="com_btn_wrap">
                <button className="com_btn s btn_request red">
                  재고 부족(45)
                </button>
                <button className="com_btn s btn_request red">
                  재고 부족(45)
                </button>
                <button className="com_btn s btn_request red">
                  재고 부족(45)
                </button>
              </div>
              <section className="com_board_search">
                <article className="search">
                  <input
                    type="search"
                    placeholder="검색할 내용을 입력해 주세요."
                    className="input s type_search"
                  />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
              </section>
            </div>
          </section>
          <section className="box box-half">
            <div className="com_board_list__top">
              <select>
                <option>중등</option>
              </select>
              <select>
                <option>2분류</option>
              </select>
              <select>
                <option>4분류</option>
              </select>
              <select>
                <option>시리즈 명</option>
              </select>
            </div>
            <hr className="com_divider" />
            <div className="com_board_list__top margin">
              <div className="board_select">
                <select className="select">
                  <option value="이지수능 (본사)">이지수능 (본사)</option>
                </select>
              </div>

              <div className="com_input_wrap">
                <div className="check">
                  <input
                    type="radio"
                    name="rdo"
                    id="rdo01"
                    className="com_chk circle"
                  />
                  <label htmlFor="rdo01">전체</label>
                  <input
                    type="radio"
                    name="rdo"
                    id="rdo02"
                    className="com_chk circle"
                  />
                  <label htmlFor="rdo02">인쇄교재</label>
                  <input
                    type="radio"
                    name="rdo"
                    id="rdo03"
                    className="com_chk circle "
                  />
                  <label htmlFor="rdo03">인쇄 /판매교재</label>
                </div>
              </div>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="5%" />
                <col width="11%" />
                <col width="9%" />
                <col width="7%" />
                <col width="9%" />
                <col width="12%" />
                <col width="12%" />
                <col width="12%" />
                <col width="9%" />
                <col width="7%" />
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>발간일</th>
                  <th>제작 방법</th>
                  <th>과목</th>
                  <th>교재코드</th>
                  <th>교재명</th>
                  <th>파일</th>
                  <th>판매가</th>
                  <th>재고</th>
                  <th>변경</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>45</td>
                  <td>2024, 05,12</td>
                  <td>인쇄/판매</td>
                  <td>수학</td>
                  <td>2314</td>
                  <td>
                    수학02 단단히
                    <br />
                    추려낸 단어집
                  </td>
                  <td>
                    <button className="btn_link blue">다운로드</button>
                  </td>
                  <td className="td_red">
                    8,000
                    <br />
                    12,000
                  </td>
                  <td>456</td>
                  <td>
                    <button className="btn_edit"></button>
                  </td>
                </tr>
                <tr>
                  <td>44</td>
                  <td>2024, 05,12</td>
                  <td>디지털</td>
                  <td>수학</td>
                  <td>2314</td>
                  <td>
                    수학02 단단히
                    <br />
                    추려낸 단어집
                  </td>
                  <td>
                    <button className="btn_link blue">다운로드</button>
                  </td>
                  <td className="td_red">
                    8,000
                    <br />
                    12,000
                  </td>
                  <td>456</td>
                  <td>
                    <button className="btn_edit"></button>
                  </td>
                </tr>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>43</td>
                      <td>2024, 05,12</td>
                      <td>디지털</td>
                      <td>수학</td>
                      <td>2314</td>
                      <td>
                        수학02 단단히
                        <br />
                        추려낸 단어집
                      </td>
                      <td>
                        <button className="btn_link blue">다운로드</button>
                      </td>
                      <td className="td_red">
                        8,000
                        <br />
                        12,000
                      </td>
                      <td>456</td>
                      <td>
                        <button className="btn_edit" />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box box-half">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_board_box">
              <div className="board_item">
                <div className="btn_row">
                  <div className="com_btn_wrap">
                    <span className="com_icon gray">창고2</span>
                    <span className="com_icon gray">영어</span>
                    <span className="com_icon gray">인쇄 교재</span>
                    <span className="com_icon gray">창고2</span>
                    <span className="com_icon gray">영어</span>
                    <span className="com_icon gray">인쇄 교재</span>
                  </div>
                  <button className="btn_edit"></button>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="txt">3214</span>
                  <span className="bar" />
                  <span className="txt">
                    개념끝장 고등수학(2023년도 상 교재)
                  </span>
                </div>
                <hr className="com_divider" />
                <div className="com_input_upload">
                  <p className="file">
                    <span className="txt">File name.pdf</span>
                    <button
                      type="button"
                      className="btn_down"
                      onClick={() => {}}
                    ></button>
                  </p>
                </div>
                <hr className="com_divider" />
                <div className="info">
                  <span className="tit">ISBN</span>
                  <span className="cont">32134654654</span>
                </div>
                <div className="info">
                  <span className="tit">판매가</span>
                  <span className="cont">9,000</span>
                </div>
                <div className="info">
                  <span className="tit">등록일</span>
                  <span className="cont">2023, 05, 13</span>
                </div>
                <hr className="com_divider" />
                <div className="txt">미노출 / 절판</div>
              </div>
            </div>
            <div className="btn_wrapper">
              <button className="com_btn black xxs">전체</button>
              <button className="com_btn lightGray xxs">입고</button>
              <button className="com_btn lightGray xxs">출고</button>
              <button className="com_btn lightGray xxs">재고조정</button>
            </div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="5%" />
                  <col width="20%" />
                  <col width="15%" />
                  <col width="15%" />
                  <col width="15%" />
                  <col width="15%" />
                  <col width="15%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>요청일</th>
                    <th>등록자</th>
                    <th>비고</th>
                    <th>교부대상</th>
                    <th>입출 권 수</th>
                    <th>재고</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>45</td>
                    <td className="td_date">2023, 05, 11 12:30</td>
                    <td>김요청305</td>
                    <td className="td_red">입고</td>
                    <td>김학생103</td>
                    <td className="td_red">-45</td>
                    <td className="td_red">400</td>
                  </tr>
                  <tr>
                    <td>45</td>
                    <td className="td_date">2023, 05, 11 12:30</td>
                    <td>김요청305</td>
                    <td className="td_red">입고</td>
                    <td>김학생103</td>
                    <td className="td_red">-45</td>
                    <td className="td_red">400</td>
                  </tr>
                  <tr>
                    <td>45</td>
                    <td className="td_date">2023, 05, 11 12:30</td>
                    <td>김요청305</td>
                    <td className="td_red">입고</td>
                    <td>김학생103</td>
                    <td className="td_red">-45</td>
                    <td className="td_red">400</td>
                  </tr>
                  <tr>
                    <td>45</td>
                    <td className="td_date">2023, 05, 11 12:30</td>
                    <td>김요청305</td>
                    <td className="td_red">입고</td>
                    <td>김학생103</td>
                    <td className="td_red">-45</td>
                    <td className="td_red">400</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="com_btn_wrap right">
              <button className="com_btn black xs btn_down_orange">
                다운로드
              </button>
            </div>
            <div className="info_box">
              <div className="detail_tit bold">상세보기</div>
              <div className="info">
                <p className="tit">선택</p>
                <div className="com_input_wrap">
                  <div className="check">
                    <input
                      type="radio"
                      name="rdo"
                      id="rdo01"
                      className="com_chk circle"
                    />
                    <label htmlFor="rdo01">입고</label>
                    <input
                      type="radio"
                      name="rdo"
                      id="rdo02"
                      className="com_chk circle"
                    />
                    <label htmlFor="rdo02">출고</label>
                    <input
                      type="radio"
                      name="rdo"
                      id="rdo03"
                      className="com_chk circle "
                    />
                    <label htmlFor="rdo03">재고조정</label>
                  </div>
                </div>
                <div className="amount_adjust">
                  <p className="tit">권 수 입력</p>
                  <button className="btn_add_gray" />
                  <button className="btn_minus_gray" />
                  <input
                    type="text"
                    className="input"
                    defaultValue={`4567000`}
                  />
                </div>
              </div>
              <div className="info ">
                <p className="tit">사유 입력</p>
                <input type="text" className="input" placeholder="사유 입력" />
              </div>
            </div>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">입력</button>
            </div>
          </section>
        </section>
      </div>
      <PopBookStock
        open={modalBookStockOpen}
        close={() => setModalBookStockOpen(false)}
      />
    </main>
  );
};

export default Stocks;
